import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Modal,
  ModalBody,
} from "react-bootstrap";
import { SalarySlipApi } from "../../../api/Ess/SalarySlip";
import SalarySlipCard from "../../schooladmin/Payroll/SalarySlipCard";
import html2pdf from "html2pdf.js";
const monthsData = [
  {
    month: "January",
    salary: "₹45,000",
    color: "#f9f3ec",
    avatarColor: "#FFB6C1",
  },
  {
    month: "February",
    salary: "₹48,500",
    color: "#ecf7f2",
    avatarColor: "#ADD8E6",
  },
  {
    month: "March",
    salary: "₹46,000",
    color: "#f0f4ff",
    avatarColor: "#90EE90",
  },
  {
    month: "April",
    salary: "₹47,200",
    color: "#fff0f0",
    avatarColor: "#FFDEAD",
  },
  { month: "May", salary: "₹50,000", color: "#fef6e4", avatarColor: "#FFA07A" },
  {
    month: "June",
    salary: "₹49,000",
    color: "#e7f5ff",
    avatarColor: "#DDA0DD",
  },
  {
    month: "July",
    salary: "₹51,500",
    color: "#f0fffa",
    avatarColor: "#B0C4DE",
  },
  {
    month: "August",
    salary: "₹52,000",
    color: "#f5f3ff",
    avatarColor: "#F08080",
  },
  {
    month: "September",
    salary: "₹53,000",
    color: "#fdf0ff",
    avatarColor: "#FAFAD2",
  },
  {
    month: "October",
    salary: "₹54,000",
    color: "#f0f8f6",
    avatarColor: "#FFE4B5",
  },
  {
    month: "November",
    salary: "₹55,000",
    color: "#fff6f0",
    avatarColor: "#98FB98",
  },
  {
    month: "December",
    salary: "₹56,000",
    color: "#f2f6fc",
    avatarColor: "#D8BFD8",
  },
];

const SalaryOverview = () => {
  const year = 2025;
  const user = JSON.parse(localStorage.getItem("school_user"));
  const handleDownload = (month) => {
    alert(`Downloading salary slip for ${month} ${year}`);
  };

  const [modal, setmodal] = useState(false);
  const { user_detail } = user || {};

  const [loading, setLoding] = useState(false);
  const [userData, setUserData] = useState([]);
  const [salaryDate, setSalaryDate] = useState("");
  const [data1, setData1] = useState([]);
  const softColors = ["#f0f9ff", "#fff5f0", "#f9f0ff", "#f0fff4", "#fffaf0"];
  const avatarColors = ["#0d6efd", "#dc3545", "#20c997", "#6610f2", "#fd7e14"];
  const [monthsData, setMonthsData] = useState([]);
  const getInitials = (monthStr) => {
    const date = new Date(monthStr + "-01");
    const month = date.toLocaleString("en-US", { month: "short" });
    return month.slice(0, 3).toUpperCase();
  };

  const formatMonth = (monthStr) => {
    const date = new Date(monthStr + "-01");
    return date.toLocaleString("en-US", { month: "long" });
  };

  const getSalaryData = async () => {
    let data = {
      school_id: user_detail.fk_school_id,
      staff_id: user_detail.staff_id,
    };
    try {
      const response = await SalarySlipApi.get_staff_salary_overview(data);
      let responseData = response.data;
      setData1(responseData);
      // console.log(response);
      const preparedData = responseData.salary_arr.map((record, index) => {
        const initials = getInitials(record.attendance_month);
        const fullMonth = formatMonth(record.attendance_month);
        const color = softColors[index % softColors.length];
        const avatarColor = avatarColors[index % avatarColors.length];

        return {
          month: fullMonth,
          initials,
          salary: record.net,
          year: new Date(record.month + "-01").getFullYear(),
          color,
          avatarColor,
          originalData: record,
        };
      });

      setMonthsData(preparedData);
    } catch (err) {
    } finally {
    }
  };

  const toggle = (i) => {
    GeneratePDF(data1, i);
  };

  useEffect(() => {
    getSalaryData();
  }, []);

  const GeneratePDF = async (data, i) => {
    console.log(data, "data");
    // startLoading();

    // Parse the stringified JSON fields in each item of data
    const UserData1 = data.salary_arr.map((item) => {
      return {
        ...item,
        presenty: JSON.parse(
          item.presenty
            .replace(/'/g, '"')
            .replace(/False/g, "false")
            .replace(/True/g, "true")
        ),
        earning: JSON.parse(
          item.earning
            .replace(/'/g, '"')
            .replace(/False/g, "false")
            .replace(/True/g, "true")
        ),
        deduction: JSON.parse(
          item.deduction
            .replace(/'/g, '"')
            .replace(/False/g, "false")
            .replace(/True/g, "true")
        ),
      };
    });
    console.log(UserData1, " : : : : : : : : UserData:: :");
    let SalaryDate = UserData1[i].created_date;
    console.log(SalaryDate, " : : : : : : : : SalaryDate:: :");

    const date = new Date(SalaryDate);

    const options = { year: "numeric", month: "long" };
    const formattedDate = date.toLocaleDateString("en-US", options);

    console.log(formattedDate);
    setSalaryDate(formattedDate);

    // Calculate the total for fixed earnings
    const calculateFixedEarningsTotal = (earnings) => {
      return earnings
        .filter((entry) => entry.is_fixed === true)
        .reduce((total, entry) => total + entry.amount, 0);
    };

    const updatedUserData = UserData1.map((user) => {
      return {
        ...user,
        fixedEarningsTotal: calculateFixedEarningsTotal(user.earning),
      };
    });

    console.log(updatedUserData, " : : : : : : : : Updated UserData:: :");

    setUserData(updatedUserData);
    setmodal(true);
  };

  const handleConvertToPdf = async () => {
    const element = document.getElementById("model-con");
    if (element) {
      const opt = {
        margin: 0, // A4 layout is already fixed
        filename: "salary_slips.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 }, // higher scale = sharper PDF
        pagebreak: { mode: "avoid" }, // don't split slips
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      };

      const pdfDataUri = await html2pdf()
        .from(element)
        .set(opt)
        .outputPdf("datauristring");

      const newTab = window.open();
      if (newTab) {
        newTab.document.write(
          `<style>body{margin:0;overflow:hidden;}</style><iframe width="100%" height="100%" src="${pdfDataUri}"></iframe>`
        );
        newTab.document.close();
      } else {
        console.error("Failed to open a new tab.");
      }
    }
  };

  console.log(modal);

  return (
    <div className="container ">
      <div className="card shadow">
        <div className="card-header bg-primary text-white">
          <h5 className="mb-0">Salary Overview</h5>
        </div>

        {monthsData.length === 0 ? (
          <div className="text-center text-muted my-4">
            Salary not generated yet
          </div>
        ) : (
          <Row className="g-4">
            {monthsData.map(({ month, salary, color, avatarColor }, index) => (
              <Col key={month} md={4} className="mb-2 mt-2">
                <Card
                  style={{
                    backgroundColor: color,
                    border: "none",
                    height: "100%",
                    marginBottom: "10px",
                  }}
                >
                  <Card.Body>
                    <div className="d-flex align-items-center mb-3">
                      <div
                        className="me-3 d-flex align-items-center justify-content-center rounded-circle"
                        style={{
                          backgroundColor: avatarColor,
                          width: 40,
                          height: 40,
                          color: "#fff",
                          fontWeight: "bold",
                          fontSize: "14px",
                        }}
                      >
                        {getInitials(month)}
                      </div>
                      <div>
                        <div className="fw-semibold mx-1">
                          Salary Sheet – {month} {year}
                        </div>
                      </div>
                    </div>

                    <div className="d-flex justify-content-end align-items-center">
                      <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={() => toggle(index)}
                      >
                        Download
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        )}
      </div>

      <Modal
        show={modal} // ✅ Correct for React-Bootstrap
        onHide={() => setmodal(false)} // ✅ Required to close modal
        size="lg" // You can use lg, xl, fullscreen, etc.
        backdrop="static"
        centered
      >
        <div className="text-right p-2">
          {loading ? (
            <div>Loading...</div>
          ) : (
            <button
              className="btn btn-primary"
              onClick={() => {
                handleConvertToPdf();
              }}
            >
              Print Salary
            </button>
          )}
          <button
            className="btn btn-secondary mx-1"
            onClick={() => setmodal(false)} // ✅ Close on click
          >
            Close
          </button>
          <hr className="border-muted" />
        </div>

        <ModalBody id="model-con" className="p-0">
          {userData.length > 0 ? (
            userData.map((item, index) => (
              <div className="salary-slip-card" key={index}>
                <SalarySlipCard
                  salaryDate={salaryDate}
                  totalDays={30}
                  userData={item}
                  id={`divToConvert`}
                  loading={loading}
                />
              </div>
            ))
          ) : (
            <p className="no-list-message" style={{ fontSize: "1.5rem" }}>
              Salary Slip Not Found!
            </p>
          )}
        </ModalBody>
      </Modal>
    </div>
  );
};

export default SalaryOverview;

// {
//     "month": "2025-07",
//     "presenty": "{'20': 20, 'present': 31}",
//     "earning": "[{'heads_name': 'New Salary ', 'staffId': 20, 'heads_type': 'Earning', 'amount': 15000, 'is_manual': False, 'is_active': True, 'is_fixed': False, 'sequence': '1'}, {'heads_name': 'New Salary 2', 'staffId': 20, 'heads_type': 'Earning', 'amount': 5000, 'is_manual': False, 'is_active': True, 'is_fixed': False, 'sequence': '2'}]",
//     "deduction": "[{'heads_name': 'NewDiduction', 'staffId': 20, 'heads_type': 'Deduction', 'amount': 500, 'is_manual': False, 'is_active': True, 'is_fixed': True, 'sequence': '3'}]",
//     "gross": "20000",
//     "total_deduction": "500",
//     "net": "19500",
//     "created_date": "2025-07-31",
//     "school_name": "Campus Pro School",
//     "designation": "Admin"
// }
